/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".line[_ngcontent-%COMP%]{width:100%}\n/*# sourceMappingURL=subscription-filter.component.css.map*/"];
export { styles as styles };
